<template>
    <!-- 文章資料 -->
    <div class="row mb-3">
        <div class="col-12">
            <Loading v-if="loading" :height="'15vh'" />
            <NoData v-else-if="articleRes.length === 0 && !loading" class="py-5"/>
            <!-- 卡片 -->
            <div class="d-flex flex-wrap justify-content-between justify-content-md-start"
                 v-if="display === 'card'">
                <ArticleCard v-for="(item, index) in articleRes"
                             :key="index"
                             class="mb-3"
                             :article="item"
                             :gaInfo="gaData"
                             :line3="true"
                             :isShowOrderNum="isShowOrderNum"
                             :index="orderNum + index + 1" />
            </div>
            <!-- 條列 -->
            <div v-for="(item, index) in articleRes"
                 :key="index"
                 class="mb-3"
                 v-else-if="display === 'list'">
                <ArticleList :article="item"
                             :isShowOrderNum="isShowOrderNum"
                             :gaInfo="gaData"
                             :type="'border'"
                             :index="orderNum + index + 1" />
            </div>
            <!-- no data -->
        </div>
    </div>
</template>
<script>
import ArticleList from '@/components/ArticleList.vue';
import ArticleCard from '@/components/ArticleCard.vue';
import NoData from '@/components/NoData.vue';
import Loading from '@/components/Loading.vue';

export default {
    name: 'ArticleDisplay',
    components: {
        ArticleCard,
        ArticleList,
        NoData,
        Loading,
    },
    props: {
        contentPage: {
            type: String,
            require: true,
        },
        currentPage: { // 算index用
            type: Number,
            default: 1,
        },
        articleRes: {
            type: Array,
            require: true,
        },
        display: {
            type: String,
            require: true,
        },
        isShowOrderNum: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            list: '文章列表',
            menu: {},
        };
    },
    mounted() {
        this.page = this.currentPage;
    },
    computed: {
        orderNum() {
            return (this.currentPage - 1) * this.size;
        },
        gaData() {
            return this.systemName + '|' + this.contentPage + '|';
        },
    },
};
</script>
<style lang="scss" scoped></style>
